export const DATE_FORMAT = "DD/MM/YYYY";
export const TIME_FORMAT = "h:mm a";
export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;
export const NEW_MESSAGE = "Add";
export const CANCEL_MESSAGE = "Cancel";
export const ORDINAL_DATE_FORMAT = "Do MMMM YYYY";
